import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=2425d35c&scoped=true"
import script from "./Lead.vue?vue&type=script&lang=js"
export * from "./Lead.vue?vue&type=script&lang=js"
import style0 from "./Lead.vue?vue&type=style&index=0&id=2425d35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2425d35c",
  null
  
)

export default component.exports